<template>
	<JBox>
		<CFormInput
			componentName="JInputText"
			name="name"
			label="Component Name"
			v-model="form.name"
			@blur="
				form.name = makePascalCase(form.name)
				$v.form.name.$touch()
			"
		>
			<JText slot="bottom" class="s-text-red-500 s-text-xs" v-if="$v.form.name.$error">
				This field is required
			</JText>
		</CFormInput>

		<!-- Loading -->
		<JSpinner class="s-mt-4 s-mb-4" type="dots" v-if="isLoading" />

		<!-- Error message -->
		<JBox class="s-bg-red-100 s-text-red-500 s-p-4 s-mt-4" v-if="errorMessage">
			{{ errorMessage }}
		</JBox>

		<JFlex class="s-justify-between s-mt-6">
			<JButton variant="default-light" @click="handleSubmit">Create Component</JButton>
			<JButton variant="white" @click="$emit('cancel')">Cancel</JButton>
		</JFlex>
	</JBox>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import camelCase from "lodash.camelcase"
import upperFirst from "lodash.upperfirst"

export default {
	validations: {
		form: {
			name: { required }
		}
	},

	data() {
		return {
			form: {},

			isLoading: false,
			errorMessage: ""
		}
	},

	methods: {
		async handleSubmit() {
			if (this.isLoading) return // prevent double submit
			this.errorMessage = "" // reset

			// Validate form
			this.$v.$touch()
			if (this.$v.$invalid) return

			// Template
			let vueTemplate = `<template><JBox></JBox></template>`
			vueTemplate += `<script>export default { data(){ return {input1: null, input2:null, input3: null, input4: null, input5: null, input6:null, input7:null,input8:null, input9:null, form: {input1: null, input2:null, input3: null, input4: null, input5: null, input6:null, input7:null,input8:null, input9:null, input10:null, input11:null, input12:null}} }}`
			vueTemplate += "</" + "script" + ">"
			const component = { name: this.form.name, vueTemplate }

			this.isLoading = true
			const { isSuccess, res } = await this.$store.dispatch("uiEditor/createComponent", component)
			this.isLoading = false

			if (!isSuccess) {
				this.errorMessage = res?.data?.createComponent?.errors?.[0] || res?.errors?.[0]?.message
				return
			}

			const createdComponent = {
				id: res?.data?.createComponent?.createdStatus?.id,
				name: this.form.name
			}

			this.$emit("created", createdComponent)
		},

		makePascalCase(value) {
			return upperFirst(camelCase(value))
		}
	}
}
</script>
